import type { NavigationCounts } from '@risksmart-app/trpc/src/types';
import type { GetImpactCountQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetImpactCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { COUNT_STALE_TIME_MS, createQueryHook } from 'src/utils';

import type { NavigationCountArgs } from '../navigation/navigationCounts';
import {
  navigationCountsQueryOptions,
  toAggregate,
} from '../navigation/navigationCounts';

export const useGetImpactCount = createQueryHook<
  NavigationCountArgs,
  NavigationCounts,
  GetImpactCountQuery
>({
  trpcQueryOptions: navigationCountsQueryOptions,
  mapTrpcDataToGraphQL: (data) => ({
    impact_aggregate: { aggregate: toAggregate(data.impact) },
  }),
  // Aggregate over a register; mutations invalidate it. See COI-882.
  trpcStaleTime: COUNT_STALE_TIME_MS,
  graphqlDocument: GetImpactCountDocument,
});
